import { v4 as uuidv4 } from 'uuid';

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

export async function askHelp(threadId: string, message: string, session: any) {
    if(!session?.idToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    try {    
        const res = await fetch(`${BFF_BASE_URL}/v1/help`,
            {
                method: 'POST',
                body: JSON.stringify({ threadId, message }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${session?.accessToken}`,
                    'x-id': `${session?.idToken}`,
                    'x-session-id': session?.sessionId || 'x-session-id',
                    'x-correlation-id': uuidv4()
                }
            }
        );
        if (!res.ok) {
            throw new Error((await res.json()).message);
        }

        return (await res.json())
    } catch {
        throw new Error('AI Assistant is offline.')
    }
}